import React, { memo } from "react";
import { ButtonPrimary } from "components/Button";
import { Link } from "react-router-dom";
import { imagePath } from "helper";
import { ButtonTextUnderline } from "components/Button";

const CardService = ({ data, ...props }) => {
  return (
    <>
      <div className="w-full relative overflow-hidden">
        <div className="relative">
          <img
            src={imagePath(data.id, data.thumbnail_image, data.collectionName)}
            alt={data.name}
            className="w-full z-[0] object-cover object-center block aspect-square"
            loading="lazy"
          />
        </div>
        <div className="service-thumb-overlay absolute w-full h-full top-0 left-0 z-[1]"></div>
        <div
          className={`absolute w-full h-full max-h-fit left-0 z-[4] home-service-drawer-content ${
            props.openDrawer[data.id] ? "open" : ""
          }`}
        >
          <div
            className={`flex flex-col justify-center items-center relative mt-[-60px] transition-all duration-300 ${
              props.openDrawer[data.id] ? "pb-16" : "pb-32"
            }`}
          >
            <div className="absolute bottom-0 left-0 right-0 m-auto w-full h-[80px] bg-[linear-gradient(0deg,rgba(0,0,0,0.94)_-31.83%,rgba(24,9,9,0)_100%)]"></div>
            <i
              onClick={() => props.handleOpenDrawer(data.id)}
              className={`ico-chevron-up relative mb-12 transition-all duration-300 ${
                props.openDrawer[data.id] ? "rotate-180" : "rotate-0"
              }`}
              style={{
                backgroundImage: 'url("/images/icon/ic-double-chevron-up.svg")',
              }}
            ></i>
            <h4 className="font-taviraj text-24 leading-[80%] text-neutral-100 relative">
              {data.name}
            </h4>
          </div>
          <div className="pt-16 pb-24 px-16 text-center border-t-[2px] border-tertiary-400 bg-primary-200 h-[178px]">
            <p className="font-light text-neutral text-16 leading-[20px] block mt-8">
              {data.description}
            </p>
            {data.name == "Web Design" && (
              <Link
                to="https://wa.me/message/IRUPCHIIQWBYH1"
                target="_blank"
                className="inline-block mt-20"
              >
                <ButtonTextUnderline className="!text-16 !leading-[20px]">
                  Learn more
                </ButtonTextUnderline>
              </Link>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(CardService);
